export enum AUTH_TYPES {
  OIDC = 'oidc',
}

export enum MODEL_FAMILY_TYPES {
  LLAMA_3_2 = 'llama_3.2',
  GEMMA_3 = 'gemma_3',
  QWEN_3VL = 'qwen_3vl',
}

export enum AppClientType {
  SERVICE_ACCOUNT = 'service_account',
  DEPLOYMENT = 'deployment',
  SYSTEM_ACCOUNT = 'system_account',
  USER_ACCOUNT = 'user_account',
}

export enum ActionTypes {
  SET_GENERATION_CONFIG = 'set_generation_config',
  SET_MODEL_CONFIG = 'set_model_config',
  USER_LOGOUT = 'logout',
  USER_FETCH = 'user',
  SET_AUTH_CONFIG = 'set_auth_config',
  SET_AUTH_USER = 'set_auth_user',
  SET_PAGE_TITLE = 'set_page_title',
  SET_DOC_TYPES = 'set_doc_types',
  FORM_SET_ERROR = 'set_error',
  FORM_CLEAR_ERROR = 'clear_error',
}

